import * as React from "react";
import ReactCardFlip from "react-card-flip";

// Material UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

// Components
import SimpleToggle from "components/SimpleToggle";
import Stopwatch from "./Stopwatch";
import CountdownTimer from "./CountdownTimer";

// Stores
import { ActivityStore } from "stores";
import { Paper } from "@material-ui/core";

export interface TimerProps extends React.Props<any> {
    activityStore: ActivityStore;
    size?: number;
}

export const MAX_BUTTON_FONT_SIZE = 18;
export const MAX_TOGGLE_FONT_SIZE = 14;
export const MAX_ICON_SIZE = 30;

enum TimerType {
    STOPWATCH = "stopwatch",
    COUNTDOWN = "countdown",
}

const Timer = (props: TimerProps) => {
    const [timerType, setTimerType] = React.useState<TimerType>(TimerType.COUNTDOWN);
    const [size, setSize] = React.useState<number>(200);

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            toggle: {
                fontSize: Math.min(props.size * 0.03, MAX_TOGGLE_FONT_SIZE),
                padding: 4,
            },
            flipContainer: {
                padding: props.size * 0.04,
            },
        })
    );
    var styles = useStyles();

    React.useEffect(() => {
        setSize(props.size * 0.6);
    });

    const handleTimerTypeChanged = (value: string) => {
        let type = value as TimerType;
        if (type !== timerType) {
            setTimerType(type);
        }
    };

    // *** Note ****

    return (
        <Grid container direction="column" justify="center" alignItems="center">
            <Grid item>
                <Paper>
                    <SimpleToggle
                        className={styles.toggle}
                        labels={["Countdown", "Stopwatch"]}
                        values={[TimerType.COUNTDOWN, TimerType.STOPWATCH]}
                        onChange={handleTimerTypeChanged}
                    />
                </Paper>
            </Grid>
            <Grid item className={styles.flipContainer}>
                <ReactCardFlip isFlipped={timerType === TimerType.STOPWATCH}>
                    <Grid container key="front">
                        <CountdownTimer size={size} activityStore={props.activityStore}></CountdownTimer>
                    </Grid>
                    <Grid container key="back">
                        <Stopwatch size={size}></Stopwatch>
                    </Grid>
                </ReactCardFlip>
            </Grid>
        </Grid>
    );
};

export default Timer;
